import Headings from "./headings"
import Texts from "./texts"

const pages = [
  { name: "headings", component: Headings },
  { name: "texts", component: Texts },
].map((page) => ({
  ...page,
  type: "page",
}))

export { pages }
